/**
 * @generated SignedSource<<ea453a98db779316d7356c6fdba896ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RegisterSuccessQuery$variables = {};
export type RegisterSuccessQuery$data = {
  readonly signupSurveyUrl: string | null;
};
export type RegisterSuccessQuery = {
  response: RegisterSuccessQuery$data;
  variables: RegisterSuccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signupSurveyUrl",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RegisterSuccessQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RegisterSuccessQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "64bbb6253de854d4660e32b75b648558",
    "id": null,
    "metadata": {},
    "name": "RegisterSuccessQuery",
    "operationKind": "query",
    "text": "query RegisterSuccessQuery {\n  signupSurveyUrl\n}\n"
  }
};
})();

(node as any).hash = "5bb330c2d05462ab8ffb0290f4006dc5";

export default node;
